<div class="pt-3 px-3 overflow-auto">
    <div *ngFor="let partial of apontamentos">
        <div class="callout border-danger mb-2">
        <div class="d-flex justify-content-between pb-2 mb-2 fs-7 text-gray-600">
            <span [ngClass]="{'text-strikethrough': partial.excluido}">{{ partial.usuarioResponsavelEmail }}</span>
            <div class="pointer" *ngIf="canAproveOrDeleteAfericao()" (click)="showDeletedCortesDialog(partial)">
            <mat-icon fontSet="material-icons-outlined" class="opacity-75">close</mat-icon>
            </div>
        </div>
    
        <div class="d-flex align-items-center">
            <div>
            <div class="text-center lh-sm" *ngIf="!checkDioFinishSameDay()">{{ partial.startAt | date:'dd/MM/yyyy' }}</div>
            <div class="text-center lh-sm" [ngClass]="{'text-strikethrough': partial.excluido}">{{ partial.dataInicio | date:'HH:mm' }}</div>
            </div>
            <mat-icon fontSet="material-icons-outlined" class="text-danger mx-3">east</mat-icon>
            <div>
            <div class="text-center lh-sm" *ngIf="!checkDioFinishSameDay()">{{ partial.endAt | date:'dd/MM/yyyy' }}</div>
            <div class="text-center lh-sm" [ngClass]="{'text-strikethrough': partial.excluido}">{{ partial.dataFim | date:'HH:mm' }}</div>
            </div>
        </div>
        <div class="border-top pt-2 mt-2 fs-7 lh-sm text-gray-600" [ngClass]="{'text-strikethrough': partial.excluido}">
            Motivo: {{ partial.motivo ? partial.motivo : '' }}
        </div>
        <div class="border-top pt-2 mt-2 fs-7 lh-sm text-gray-600" [ngClass]="{'text-strikethrough': partial.excluido}">
            Regras: {{ partial.regrasStr }}
        </div>
        <div class="border-top pt-2 mt-2 fs-7 lh-sm text-gray-600" *ngIf="!partial.excluido">
            <button (click)="showCancelarApontamentoDialog(partial)">Cancelar Apontamento</button>
        </div>
        </div>
    </div>
</div>